<template>
  <div class="tab-table-wrapper">
    <!-- 只有在 MenuList 里存在的才显示 -->
    <div class="tab-list">
      <el-button
        v-for="item in authorizedTabs"
        :key="item.value"
        :type="activeTab === item.value ? 'primary' : 'default'"
        @click="handleTabChange(item.value)"
      >
        {{ item.label }}
      </el-button>
    </div>

    <!-- 只渲染有权限的组件 -->
    <div class="tab-content" v-if="activeTab">
      <component :is="activeTab" :key="activeTab" />
    </div>
  </div>
</template>

<script>
// 你的组件
import NationalStructure from './components/NationalStructure.vue'
import AdminSubject from './components/AdminSubject.vue'
import AdminSemester from './components/AdminSemester.vue'
import SchoolSemester from './components/SchoolSemester.vue'
import SchoolSubjectList from './components/SchoolSubjectList.vue'
import AdminBasic from './components/AdminBasic.vue'
export default {
  name: 'TabTableContainer',
  components: {
    nationalStructure: NationalStructure,
	adminSubject:AdminSubject,
	adminSemester:AdminSemester,
	schoolSemester:SchoolSemester,
	schoolSubjectList:SchoolSubjectList,
	adminBasic:AdminBasic,
  },
  data() {
    return {
      tabs: [
		{ label: '学校学科', value: 'schoolSubjectList' },
		{ label: '学校学期', value: 'schoolSemester' },
		{ label: '基础学科', value: 'adminSubject' },
		{ label: '基础学期', value: 'adminSemester' },
        { label: '全国基础信息', value: 'nationalStructure' },
		{ label: '内部基础信息', value: 'adminBasic' },
      ],
      activeTab: ''
    }
  },
  computed: {
    // 从 localStorage 读取菜单权限
    menuList() {
      try {
        return localStorage.getItem('MenuList') || ''
      } catch (e) {
        return ''
      }
    },

    // 核心：只保留 MenuList 中存在的 tab
    authorizedTabs() {
      return this.tabs.filter(tab => {
		  return tab
        // return this.menuList.includes(tab.value)
      })
    }
  },
  created() {
    this.setDefaultTab()
  },
  methods: {
    handleTabChange(value) {
      this.activeTab = value
	  localStorage.setItem('BasicSettings',value)
    },
    // 默认选中第一个有权限的
    setDefaultTab() {
      if (this.authorizedTabs.length > 0) {
		  if(localStorage.getItem("BasicSettings")){
			  this.handleTabChange(localStorage.getItem("BasicSettings"))
		  }else{
			  this.activeTab = this.authorizedTabs[0].value
		  }
      }
    }
  }
}
</script>

<style scoped>
.tab-table-wrapper {
  width: 100%;
  padding: 12px;
}
.tab-list {
  display: flex;
  gap: 0px;
  margin-bottom: 15px;
}
.tab-content {
  width: 100%;
}
</style>